module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/reminder-surface-warning-l-24.5b5a0fcd.svg";